export function startAutoScroll () {
  setInterval(() => {
    const modals = document.querySelector('.modal-content')
    document.body.style.position = modals ? 'fixed' : ''
  }, 100)
}
